import React from 'react';

const Supports = () => {
    return (
    <div className="p-6 max-w-4xl mt-48 mx-auto">
      <h1 className="text-3xl font-bold mb-4">Support Policy</h1>
      <p className="mb-4">At Saiaquapets, we prioritize the quality of our products and customer service. Our goal is to provide a seamless and satisfying experience. Please review our support policy to understand our terms and conditions regarding purchases, as we do not offer returns or refunds under most circumstances.</p>
      
      <h2 className="text-2xl font-semibold mt-6">1. Customer Support Availability</h2>
      <p className="mb-2">Our team is available to address inquiries, troubleshoot issues, and offer guidance regarding our products.</p>
      <ul className="list-disc pl-6 mb-4">
        <li>Phone: +91 63838 89291</li>
        <li>Email: <a href="mailto:support@saiaquapets.com" className="text-blue-500">support@saiaquapets.com</a></li>
        <li>Live Chat: Available on our website during the following hours: <strong>9:00 AM – 6:00 PM IST, Monday to Saturday</strong></li>
      </ul>
      <p className="mb-4">Please contact us via phone or email with any urgent concerns. All emails will be responded to within 24-48 hours.</p>
      
      <h2 className="text-2xl font-semibold mt-6">2. No Return or Refund Policy</h2>
      <p className="mb-4">At Saiaquapets, all sales are final. We do not accept returns or process refunds on any products, including aquarium supplies, fish, and other aquatic life.</p>
      
      <h3 className="text-xl font-semibold mt-4">Aquarium Supplies and Equipment:</h3>
      <p className="mb-4">All products are sold with no returns or refunds. Please confirm compatibility before purchasing. If there are technical issues, refer to the manufacturer’s warranty.</p>
      
      <h3 className="text-xl font-semibold mt-4">Live Fish and Aquatic Animals:</h3>
      <p className="mb-4">No returns or refunds are allowed once shipped or delivered, except in cases of dead-on-arrival (DOA).</p>
      <ul className="list-disc pl-6 mb-4">
        <li>Provide clear photos/videos of the unopened package within 2 hours of delivery.</li>
        <li>Ensure proper water conditions and care instructions.</li>
        <li>If verified, a replacement will be offered, but no monetary refunds.</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6">3. Dead-On-Arrival (DOA) Claims for Live Fish</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Contact us immediately upon delivery.</li>
        <li>Submit proof (photos of unopened packaging with shipping water intact).</li>
        <li>Replacements depend on availability. No returns/exchanges once fish are introduced to your tank.</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6">4. Warranty and Repair for Equipment</h2>
      <p className="mb-4">Certain products are covered under the manufacturer’s warranty. Contact the manufacturer directly for troubleshooting, repairs, or warranty claims.</p>
      
      <h2 className="text-2xl font-semibold mt-6">5. Shipping and Delivery Responsibility</h2>
      <p className="mb-4">We use trusted couriers to ensure safe delivery, but once handed over to the carrier, we are not liable for delays, mishandling, or loss.</p>
      <ul className="list-disc pl-6 mb-4">
        <li>Ensure accurate delivery details during checkout.</li>
        <li>Customers are responsible for any reshipping fees due to incorrect addresses or refusal.</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6">6. Customer Responsibility for Aquarium Conditions</h2>
      <p className="mb-4">Proper care begins upon arrival. Customers must maintain optimal aquarium conditions.</p>
      <ul className="list-disc pl-6 mb-4">
        <li>No refunds/replacements for fish loss due to incorrect water conditions or improper care.</li>
        <li>We recommend quarantining new fish and monitoring water quality closely.</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6">7. No Refunds on Shipping Costs</h2>
      <p className="mb-4">All shipping fees are non-refundable, including those related to DOA claims. Customers must cover shipping fees for replacement orders.</p>
      
      <h2 className="text-2xl font-semibold mt-6">8. Escalation of Unresolved Issues</h2>
      <p className="mb-4">If you require further assistance beyond our initial response, email <a href="mailto:escalation@saiaquapets.com" className="text-blue-500">escalation@saiaquapets.com</a>. We will review your case within 72 hours.</p>
      
    </div>
  );
}

export default Supports;
